export const POLOS = [
  { nome: "Brás", uf: "SP" },
  { nome: "Bom Retiro", uf: "SP" },
  { nome: "25 de Março", uf: "SP" },
  { nome: "Santa Ifigênia", uf: "SP" },
  { nome: "Feirinha da Madrugada", uf: "SP" },
  { nome: "Limeira", uf: "SP" },
  { nome: "Franca", uf: "SP" },
  { nome: "Nova Friburgo", uf: "RJ" },
  { nome: "Caruaru", uf: "PE" },
  { nome: "Goiânia", uf: "GO" },
  { nome: "Cianorte", uf: "PR" },
  { nome: "Nova Serrana", uf: "MG" },
  { nome: "Outro", uf: null },
] as const;

export type Polo = typeof POLOS[number];

export const getPoloLabel = (polo: Polo | string | null) => {
  if (!polo) return "";
  if (typeof polo === 'string') {
    const found = POLOS.find(p => p.nome === polo);
    if (found) return found.uf ? `${found.nome} (${found.uf})` : found.nome;
    return polo;
  }
  return polo.uf ? `${polo.nome} (${polo.uf})` : polo.nome;
};
